import { TFunction } from 'i18next';
import { z } from 'zod';

export const buildValidationSchema = (t: TFunction) => {
  const validationFields = {
    name: z.string().min(1, t('error.form.required')).max(128).default(''),
  };

  return z.object(validationFields);
};
